import React, { Component } from 'react'
import { connect } from 'react-redux'
import {TestConnection,ConnectionsAPI} from '../actions'
import {ReactComponent as SERVERNETWORKOFF} from '../build/images/server-network-off.svg'
import {ReactComponent as PHONEOFF} from '../build/images/phone-off.svg'
import {ReactComponent as BULLETEDOFF} from '../build/images/message-bulleted-off.svg'


const mapStateToProps = (state) => {
    return {
       ConectionsAPI: state.connectionsapi
    };
  }

  const mapDispatchToProps = dispatch => {
    return {
      TestConection: post => {
        dispatch(TestConnection(post));
      },
      ReconectionAPIDB: post => {
        dispatch(ConnectionsAPI(true,true,true,''));
        dispatch(TestConnection(post));
      }
    };
  };

 class ErrorMessage extends Component {

    Reconection(){
        this.props.ReconectionAPIDB()
    }

render(){

    const { ConectionsAPI } = this.props

    return(
            <>
                    
                            {
                                (() => { 
                                            if(ConectionsAPI.sip === false){
                                                return (
                                                    <div className="lost-api lost-api--sip">
                                                        <div className="lost-api__content">
                                                            <div className="lost-api__content__title">
                                                                <div className="lost-api__content__title__icon"> 
                                                                    <i className="lost-api__content__title__icon--sip">
                                                                        <PHONEOFF/>
                                                                    </i>
                                                                </div>
                                                            <div className="lost-api__content__title__text">A conexão com SIP foi perdida</div>        
                                                            </div>
                                                            <div className="lost-api__content__btn">Reconectar</div>
                                                        </div>
                                                        <div className="lost-api__layer"></div>
                                                    </div>
                                                );
                                            }else if(ConectionsAPI.imsdn === false){
                                                return (
                                                    <div className="lost-api lost-api--imsdn">
                                                        <div className="lost-api__content">
                                                            <div className="lost-api__content__title">
                                                                <div className="lost-api__content__title__icon"> 
                                                                    <i className="lost-api__content__title__icon--imsdn">
                                                                        <BULLETEDOFF/>
                                                                    </i>    
                                                                </div>
                                                            <div className="lost-api__content__title__text">A conexão com IMSDN foi perdida</div>        
                                                            </div>
                                                            <div className="lost-api__content__btn">Aguardando...</div>
                                                        </div>
                                                        <div className="lost-api__layer"></div>
                                                    </div>
                                                );
                                            }else if(ConectionsAPI.db === false){
                                                return (
                                                    <div className="lost-api lost-api--db">
                                                        <div className="lost-api__content">
                                                            <div className="lost-api__content__title">
                                                                <div className="lost-api__content__title__icon"> 
                                                                    <i className="lost-api__content__title__icon--db">
                                                                        <SERVERNETWORKOFF/>
                                                                    </i>   
                                                                </div>
                                                            <div className="lost-api__content__title__text">{ConectionsAPI.mensagem}</div>        
                                                            </div>
                                                            <div className="lost-api__content__btn" onClick={e => this.Reconection(e)}>Reconectar</div>
                                                        </div>
                                                        <div className="lost-api__layer"></div>
                                                   </div>   
                                                );
                                            }
                                        }
                                )()
                            }
        </>              
    )}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(ErrorMessage);